import React, { useState, useEffect } from 'react'

//Bibliotecas
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import styled from 'styled-components';
//Componentes
import { CustomButton } from '../../common/Button';
//Imágenes
import { X, Check, HelpCircle } from 'react-feather';
//Estilos
import './ActividadArrastrar.scss'

function ActividadArrastrar({ data, isOk, setIsOk, pistas, setPistas }) {

    //Lógica de interacción de drag and drop
    const onDragEnd = (result, columns, setColumns) => {
        if (!result.destination) return;
        const { source, destination } = result;
        if (source.droppableId !== destination.droppableId) {
            const sourceColumn = columns[source.droppableId];
            const destColumn = columns[destination.droppableId];
            const sourceItems = [...sourceColumn.items];
            const destItems = [...destColumn.items];
            const [removed] = sourceItems.splice(source.index, 1);
            destItems.splice(destination.index, 0, removed);
            setColumns({
                ...columns,
                [source.droppableId]: {
                    ...sourceColumn,
                    items: sourceItems
                },
                [destination.droppableId]: {
                    ...destColumn,
                    items: destItems
                }
            });
        } else {
            const column = columns[source.droppableId];
            const copiedItems = [...column.items];
            if (copiedItems.length <= 3) {
                const [removed] = copiedItems.splice(source.index, 1);
                copiedItems.splice(destination.index, 0, removed);
                setColumns({
                    ...columns,
                    [source.droppableId]: {
                        ...column,
                        items: copiedItems
                    }
                });
            }
        }
    };

    //Lógica de obtención de pistas
    function handleClue() {
        setPistas(pistas + 1);
        Object.entries(columns).forEach(([columnId, column], index) => {
            column.items.forEach((item, i) => {
                item.ok = 'right';
                if (column.name != item.respuesta) {
                    item.ok = 'wrong';
                }
            });
        });

    }

    //Lógica de verificación de la actividad
    function checkOk() {
        let verification = true;
        Object.entries(columns).forEach(([columnId, column], index) => {
            column.items.forEach(item => {
                if (column.name != item.respuesta) {
                    verification = false;
                }
            });
        });

        verification ? setIsOk(true) : setIsOk(false);
    }

    //Estados
    const [columns, setColumns] = useState(data);

    //Inicializar actividad
    useEffect(() => {
        setPistas(0);
        setIsOk(false);
        checkOk();
    }, [setIsOk, columns])

    useEffect(() => {
        Object.entries(columns).forEach(([columnId, column], index) => {
            column.items.forEach((item, i) => {
                item.ok = '';
            });
        });
    }, [])
    

    return (
        <GridBox isOf2={Object.entries(columns).length==3?true:false}>
            <DragDropContext onDragEnd={result => { onDragEnd(result, columns, setColumns) }}>
                {Object.entries(columns).map(([columnId, column], index) => {
                    return (
                        <Wrapper key={columnId} className={`div${index + 1}`}>
                            {columnId == '99' &&
                                <ActivityInfo>
                                    <h2>Actividad</h2>
                                    <p>Arrastra los datos que se encuentran en la parte inferior y ubícalos en los recuadros que están a la izquierda según corresponda</p>
                                    <CustomButton onClick={handleClue}><HelpCircle />Obtener una pista</CustomButton>
                                </ActivityInfo>
                            }
                            <Title>{column.name}</Title>
                            <DroppableWrapper>
                                <Droppable droppableId={columnId} key={columnId} direction={columnId == '99' ? 'vertical' : 'vertical'}>
                                    {(provided, snapshot) => {
                                        return (
                                            <DroppableContainer
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}
                                                isDraggingOver={snapshot.isDraggingOver}
                                                isLast={columnId == '99' ? true : false}
                                            >
                                                {column.items.map((item, index) => {
                                                    return (
                                                        <Draggable
                                                            key={item.id}
                                                            draggableId={item.id}
                                                            index={index}>
                                                            {(provided, snapshot) => {
                                                                return (
                                                                    <DraggableContainer
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        isDragging={snapshot.isDragging}
                                                                        className={`drag-item ${item.ok ? item.ok : undefined}`}>
                                                                        <span>{item.content}</span>
                                                                        <div>
                                                                            <X />
                                                                            <Check />
                                                                        </div>
                                                                    </DraggableContainer>

                                                                );
                                                            }}
                                                        </Draggable>
                                                    );
                                                })}
                                                {provided.placeholder}
                                            </DroppableContainer>
                                        );
                                    }}
                                </Droppable>
                            </DroppableWrapper>
                        </Wrapper>
                    );
                })}
            </DragDropContext>
        </GridBox>
    )
}

export default ActividadArrastrar

const GridBox = styled.div`
    display: grid;
    grid-template-columns:repeat(3, 1fr);
    grid-template-rows: auto/repeat(3, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    
    width:95%;
    justify-content:center;
    margin-right:32px;
    

    .div1 { grid-area: 1 / 1 / 2 / 2; }
    .div2 { grid-area: 1 / 2 / 2 / 3; }
    .div3 { grid-area: 2 / 1 / 3 / 2; }
    .div4 { grid-area: 2 / 2 / 3 / 3; }
    .div5 { grid-area: 3 / 1 / 4 / 3; }
    .div6 { grid-area: 1 / 3 / 4 / 4; }

    ${({isOf2}) => isOf2 &&`
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(2, 1fr);  
        .div1 { grid-area: 1 / 1 / 2 / 3; }
        .div2 { grid-area: 2 / 1 / 3 / 3; }
        .div3 { grid-area: 1 / 3 / 3 / 4; }
        min-height:80vh;
  `}

  
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content:center;
    padding:16px 0;
    max-height:100%;
`;

const Title = styled.h2`
    color:var(--color-blanco);
    margin-bottom:8px;
`;

const DroppableWrapper = styled.div`
    width:90%;
    height: 100%;
`;


const DroppableContainer = styled.div`
    box-sizing:border-box;
    background: ${props => props.isDraggingOver ? 'var(--color-azul-oscuro)' : 'var(--color-morado-claro)'};
    padding: 16px;
    width: ${props => props.isLast ? '350px' : '100%'};
    min-height:150px;
    border: 3px dashed var(--color-blanco);
    border-radius:10px;
    align-items:center;
    text-align:center;
    margin:0 auto;
    justify-content:center;
    display:flex;
    flex-direction:column;

    ${({ isLast }) => isLast && `
        display:grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(1fr);
        background-color:transparent;
        box-shadow:none;
        padding: 0px;
        div{
            width:auto;
        }
  `}

   

`;
const DraggableContainer = styled.div`
    box-sizing:border-box;
    padding: 8px 16px;
    margin: 8px;
    height: 50px;
    background: ${props => props.isDragging ? 'var(--color-gris-oscuro)' : 'var(--color-gris-claro)'};
    border-radius:10px;
    color:${props => props.isDragging ? 'var(--color-blanco)' : 'var(--color-negro)'};
    font-weight:700;
    display:flex;
    justify-content:center;
    align-items:center;
    width:250px;

    div svg{
        background-color:${props => props.isDragging ? 'var(--color-blanco)' : undefined};
        border-radius:50%;
    }
`;

const ActivityInfo = styled.div`
   display:flex;
   flex-direction:column;
   width:80%;
   justify-content:center;
   align-items:center;
   text-align:center;
   color:var(--color-blanco);
   margin-bottom:16px;

   h2{
    color:var(--color-azul-claro);
    margin-bottom:16px;
   }
`;